var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

if ($.browser.msie && $.browser.version <= 10) {
  $(".fancybox").fancybox();
  $("#browser-redirect").fancybox().trigger('click');
  sw.track('ie7-beware', { });
}
